import {
  CLINIC_ADMIN_SIGNUP_REQUEST,
  CLINIC_ADMIN_SIGNUP_REQUEST_FAILURE,
  CLINIC_ADMIN_SIGNUP_REQUEST_SUCCESS,
  SET_SIGN_UP_DATA_LOCAL,
} from '../../actions/actionTypes'
import { clinicAdminSignupActions, ClinicAdminSignUpInterface } from '../../schema/auth/signUpSchema'

const initialState: ClinicAdminSignUpInterface = {
  signUpLoader: false,
  signUpData: null,
  signUpError: '',
  signUpDataLocal: {
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    mobile_number: '',
    confirm_password: '',
    show_password: false,
    show_confirm_password: false,
    clinic_name: '',
    location: '',
    latitude: '',
    longitude: '',
  },
}
const clinicAdminSignUpReducer = (state = initialState, action: clinicAdminSignupActions) => {
  switch (action.type) {
    case CLINIC_ADMIN_SIGNUP_REQUEST:
      return {
        ...state,
        signUpLoader: true,
      }
    case CLINIC_ADMIN_SIGNUP_REQUEST_SUCCESS:
      return {
        ...state,
        signUpLoader: false,
        signUpData: action.payload,
        signUpError: null,
      }
    case CLINIC_ADMIN_SIGNUP_REQUEST_FAILURE:
      return {
        ...state,
        signUpLoader: false,
        signUpData: null,
        signUpError: action.payload.signUpError,
      }
    case SET_SIGN_UP_DATA_LOCAL:
      return {
        ...state,
        signUpDataLocal: action.payload,
      }
    default:
      return {
        ...state,
      }
  }
}
export default clinicAdminSignUpReducer
